import { FAQAreaClient } from '@/app/components/PageBuilder/FAQAreaClient'
import { FaqArea, FaqQueryResult } from '@/sanity.types'

type FAQAreaComponentProps = {
  block: FaqArea & { _key?: string }
  index: number
  pageId?: string
  pageType?: string
  faqData?: FaqQueryResult | null
}

/**
 * FAQArea component that renders FAQ content with server-fetched data.
 * The FAQ data is fetched server-side in the page component when an faqArea
 * section is detected, ensuring the content is indexed by search engine crawlers.
 * The interactive filtering is handled by the FAQAreaClient component.
 */
export default function FAQArea({ faqData }: FAQAreaComponentProps) {
  // Render the client component with server-fetched data
  return <FAQAreaClient faqData={faqData || null} />
}
